module.exports = __webpack_public_path__ + "static/media/LETTER.7eda1450.pdf";